import React, { useEffect } from 'react'
import {
  Container, Row, Col, Button,
  Card, CardHeader, CardBody
} from 'reactstrap'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import _ from 'lodash'

import CKEditor from 'components/RTE/index'
import PageTitle from 'components/Title/PageTitle'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import OpeningHourHOC from './actions'

import Lang from 'Lang/General'

const OpeningHour = props => {

  useEffect( () => {
    props.getOpeningHour()
  }, [] )

  return (
    <>
      <PageTitle
        heading={ Lang[ 'INJOY360_OPENING_HOUR' ][ props.selectedLanguage ] }
        icon="pe-7s-file icon-gradient bg-happy-itmeo" />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={ true }
        transitionAppearTimeout={ 0 }
        transitionEnter={ false }
        transitionLeave={ false }>
        <Container fluid>
          <Row>
            <Col md={ 12 }>
              <Card className="main-card mb-3">
                <CardHeader>{ Lang[ 'INJOY360_OPENING_HOUR_HEADER' ][ props.selectedLanguage ] }</CardHeader>
                  <CardBody>
                    <CKEditor
                      data={ props.openingHour }
                      onChange={ ( event, editor ) => {
                        let data = editor.getData()
                        props.onChangeOpeningHourHOC( "openingHour", data )
                      }}
                    />
                    {
                      (
                        (
                          !_.isEmpty( props.selectedCenter.center ) &&
                          (
                            ( props.profile.id === props.selectedCenter.center.client.user_id ) ||
                            ( 
                              props.profile.role === 'Center Admin' &&
                              _.findIndex( props.profile.centers, { id: props.selectedCenter.center.id } ) > -1
                            )
                          )
                        ) ||
                        props.profile.role === 'Super Admin' ||
                        props.profile.role === 'Management Admin'
                      ) && (
                        <Button
                          color="primary"
                          className="float-right mt-2"
                          onClick={ () => props.isNewOpeningHour
                            ? props.createOpeningHour( props.openingHour )
                            : props.updateOpeningHour( props.openingHour )
                          }>
                          { Lang[ 'SUBMIT' ][ props.selectedLanguage ] }
                        </Button>
                      )
                    }
                  </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      { props.onLoadOpeningHour && <LoadingOverlay /> }
    </>
  )
}

export default OpeningHourHOC( OpeningHour )
